@if (form && control) {
  <div [formGroup]="form">
    <app-material-textarea
      [formControlName]="field_name"
      [require]="require"
      [rows]="rows">
      <ng-content></ng-content>
    </app-material-textarea>
  </div>
}
